

import React from 'react';

import './StrategyBanner.css';

const StrategyBanner = () => {

  return (
    <div className="strategy-banner">
      <p>NO ES SOLO DISEÑO, ES ESTRATEGIA QUE EDUCA,<br/> CONECTA Y VENDE</p>
    </div>
  );
};

export default StrategyBanner;


